var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8933 3.15331L8.00001 7.04665L4.10668 3.15331C3.84668 2.89331 3.42668 2.89331 3.16668 3.15331C2.90668 3.41331 2.90668 3.83331 3.16668 4.09331L7.06001 7.98665L3.16668 11.88C2.90668 12.14 2.90668 12.56 3.16668 12.82C3.42668 13.08 3.84668 13.08 4.10668 12.82L8.00001 8.92665L11.8933 12.82C12.1533 13.08 12.5733 13.08 12.8333 12.82C13.0933 12.56 13.0933 12.14 12.8333 11.88L8.94001 7.98665L12.8333 4.09331C13.0933 3.83331 13.0933 3.41331 12.8333 3.15331C12.5733 2.89331 12.1533 2.89331 11.8933 3.15331Z",
    fill: "#2F333C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.b310e3e96959d5c45994dafe36b11dbc.svg";
export { ForwardRef as ReactComponent };